import { useState } from "react";
import { Button, Card, Field, inputClass } from "@/components/ui";
import { sendMagicLink } from "@/lib/supabase";

/** D-4: email magic link against an allow-list. There is no sign-up form, by design. */
export function Login() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit() {
    setBusy(true);
    setError(null);
    try {
      await sendMagicLink(email.trim().toLowerCase());
      setSent(true);
    } catch (e) {
      setError(
        e instanceof Error
          ? e.message
          : "Could not send the link. Check the address is on the allow-list.",
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-dvh items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <h1 className="mb-1 text-xl font-semibold tracking-tight text-primary">Cornerstone</h1>
        <p className="mb-5 text-sm text-fg-muted">
          Leads, deals, vendors and the event ledger.
        </p>
        <Card>
          {sent ? (
            <div data-testid="magic-link-sent">
              <p className="text-sm font-medium">Check your email.</p>
              <p className="mt-1 text-xs text-fg-muted">
                A sign-in link is on its way to {email}. It expires in an hour.
              </p>
              <Button className="mt-3" size="sm" variant="ghost" onClick={() => setSent(false)}>
                Use a different address
              </Button>
            </div>
          ) : (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                void submit();
              }}
              className="space-y-3"
            >
              <Field label="Email address" required>
                <input
                  type="email"
                  required
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  data-testid="login-email"
                  className={inputClass}
                />
              </Field>
              <Button
                type="submit"
                variant="primary"
                disabled={busy || !email.includes("@")}
                data-testid="login-submit"
                className="w-full"
              >
                {busy ? "Sending…" : "Send magic link"}
              </Button>
              {error && (
                <p role="alert" className="text-xs text-danger" data-testid="login-error">
                  {error}
                </p>
              )}
              <p className="text-[11px] leading-snug text-fg-muted">
                Access is by invitation only. If your address is not on the allow-list, no link
                will be sent.
              </p>
            </form>
          )}
        </Card>
      </div>
    </div>
  );
}
